import isEmpty from 'lodash/isEmpty'
import merge from 'lodash/merge'
import type { FunctionComponent } from 'react'
import React, { useContext as useContextCore } from 'react'
import { components as defaultComponents } from './components'
import type { UseListResult } from '@ztechapps/common.hook'
import { useTemplateList } from '@ztechapps/common.hook'

export type Components = {
  ListRow?: FunctionComponent
  ListHead?: FunctionComponent
  AddNewTemplateButton?: FunctionComponent
  TemplateInputValue?: FunctionComponent
  TemplateDisplayValue?: FunctionComponent
}

export type ProviderProps = {
  onFilter?: (props: { template: Record<any, any> }) => void
  components?: Components
  filter?: any
  category: string
  sort?: any
  onChange?: any
  canAdd?: boolean
  height?: number
  children: React.ReactNode
}

type ContextType = {
  parentOnFilter: (props: { template: Record<any, any> }) => void
} & Omit<ProviderProps, 'children' | 'onFilter'> &
  UseListResult

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

/**
 * @param category -  the category of the template
 * @param canAdd - this flag determines whether to show the add template button or not
 * @param height - the height of template table
 */
export const TemplateProvider = ({ children, components, filter, category, sort, canAdd = true, onFilter, ...props }: ProviderProps) => {
  components = merge({}, defaultComponents, components)

  sort = sort ?? { name: 1 }
  filter = filter ?? {}
  if (isEmpty(filter) && !isEmpty(category)) {
    //set the default filter as category when the filter was not specified
    filter = { category }
  }

  //get the templates,
  const allTemplates = useTemplateList({ filter, sort })

  return <CoreProvider value={{ ...props, components, category, canAdd, parentOnFilter: onFilter, ...allTemplates }}>{children}</CoreProvider>
}

export const useTemplateContext = () => useContextCore(context)
